import React, { useEffect, useRef } from 'react';

import { ReactComponent as CloseIcon } from 'i/icons/close.svg';
import { BlockHeading } from 'components/BlockHeading';
import { useTranslation } from 'react-i18next';
import usePopup from './usePopup';

const DeletePositionPopup = ({ isOpen }) => {
	const { popupFrame, popupData, closePopup } = usePopup({
		isOpen,
		extraClassName: 'popup_in--delete_position_state',
	});
	const { t } = useTranslation('deletePositionPopup');
	const $deleteButton = useRef(null);

	const handleDeletePosition = () => {
		closePopup();
		if (popupData.confirmDialog) {
			popupData.confirmDialog(true);
		}
	};

	useEffect(() => {
		if (isOpen) {
			$deleteButton.current.focus();
		}
	}, [isOpen]);

	return popupFrame(
		<div className="delete_position">
			<button className="popup_close" type="button" onClick={closePopup}>
				<CloseIcon className="icon icon-close size_mod" />
			</button>
			<BlockHeading title={t('title')} iconName="question" offsetMod />
			<div className="delete_position__text">{t('description')}</div>
			<div className="delete_position__button">
				<button
					className="btn_base"
					type="button"
					onClick={handleDeletePosition}
					ref={$deleteButton}
				>
					{t('deleteButton')}
				</button>
			</div>
		</div>
	);
};

export default DeletePositionPopup;
